import { addDayToDate } from '@feathr/hooks';

import type { IDashboardUrlState, TDateRange } from '../ReportsConversionsDashboardPage.utils';

/**
 * Builds the URLSearchParams for `Conversions.export`.
 *
 * Today's BE (`anhinga app/views/conversions.py ConversionExportView`) accepts
 * only `campaign | flight | event`, `start`, `end`, `attribution_model`,
 * `email`. No account-scoped export, no filter args. The integration ticket
 * (§2) lifts that limitation; once landed, this function should also forward
 * `state.projects`, `state.types`, and `state.archived`. Until then, the CSV
 * matches the dashboard's timeframe + attribution but ignores filter chips.
 *
 * `end` is wrapped with `addDayToDate` to match the inclusive-upper-bound
 * convention used by every other Conversions.export caller in the app
 * (ConversionTableCard.hooks.ts, ConversionTableCardV1, etc.).
 */
export function buildExportParams(
  state: IDashboardUrlState,
  range: TDateRange,
  email: string,
): URLSearchParams {
  const params = new URLSearchParams();
  params.set('attribution_model', state.attr);
  params.set('start', range[0]);
  params.set('end', addDayToDate(range[1]));
  params.set('email', email);
  return params;
}
